import RewardsMcom from './Rewards.mcom';
import RewardsBcom from './Rewards.bcom';

export default import.meta.env.VITE_ENTRY_POINT === 'bcom' ? RewardsBcom : RewardsMcom;
